import { defineComponent as _defineComponent } from 'vue'
import {
  Modal,
  Heading,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary,
  SingleInput
} from '@warrenbrasil/nebraska-web';
import { ref, computed } from 'vue';

interface Props {
  isOpen: boolean;
  isPasswordInvalid: boolean;
  isLoading: boolean;
}

interface EmitEvents {
  (event: 'close'): void;
  (event: 'confirm', inputPassword: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VerifyPassword',
  props: {
    isOpen: { type: Boolean },
    isPasswordInvalid: { type: Boolean },
    isLoading: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(__props: any) {

const props = __props as {
  isOpen: boolean;
  isPasswordInvalid: boolean;
  isLoading: boolean;
}





const inputPassword = ref('');

const computedPasswordStatus = computed(() => {
  return props.isPasswordInvalid ? 'error' : '';
});

return { __sfc: true,props, inputPassword, computedPasswordStatus, Modal, Heading, ButtonContainer, ButtonPrimary, ButtonSecondary, SingleInput }
}

})